export const siteSettings = {
  name: "Trades Catalyst",
  link: "https://tradexcatalyst.com",
  email: "support@tradexcatalyst.com",
  appLink: "https://app.tradexcatalyst.com",
};
